"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchSelect = SearchSelect;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _search = require("../../../assets/icons/search.svg");
var _react = _interopRequireWildcard(require("react"));
var _combobox = require("@reach/combobox");
var _classnames = _interopRequireDefault(require("classnames"));
var _InputWithIcon = require("../../../elements/input-with-icon/InputWithIcon");
var _Paper = require("../../../elements/paper/Paper");
var _Option = require("../../../elements/option/Option");
var _remove = require("../../../assets/icons/remove.svg");
var _plusCircled = require("../../../assets/icons/plus-circled.svg");
var _chevronDown = require("../../../assets/icons/chevron-down.svg");
var _usePopoverControl2 = require("./hooks/usePopoverControl");
var _CallbackOnClose = require("./callback-on-close/CallbackOnClose");
var _useSearchTerm2 = require("./hooks/useSearchTerm");
var _useSelectHandlers2 = require("./hooks/useSelectHandlers");
var _searchSelectModule = _interopRequireDefault(require("./search-select.module.scss"));
var _noop = require("../../../utils/noop");
var _useFixSelectedValueOnClose = require("./hooks/useFixSelectedValueOnClose");
var _useTranslation2 = require("../../../hooks/useTranslation/useTranslation");
/* eslint-enable prettier/prettier */

function SearchSelect(_ref) {
  var onChange = _ref.onChange,
    options = _ref.options,
    id = _ref.id,
    className = _ref.className,
    name = _ref.name,
    disabled = _ref.disabled,
    placeholder = _ref.placeholder,
    error = _ref.error,
    value = _ref.value,
    _ref$inModal = _ref.inModal,
    inModal = _ref$inModal === void 0 ? false : _ref$inModal,
    _ref$withAddNew = _ref.withAddNew,
    withAddNew = _ref$withAddNew === void 0 ? false : _ref$withAddNew,
    _ref$clearable = _ref.clearable,
    clearable = _ref$clearable === void 0 ? true : _ref$clearable,
    addNewLabel = _ref.addNewLabel,
    _ref$onAddNewClick = _ref.onAddNewClick,
    onAddNewClick = _ref$onAddNewClick === void 0 ? _noop.noop : _ref$onAddNewClick,
    _ref$onSearchTermChan = _ref.onSearchTermChange,
    onSearchTermChange = _ref$onSearchTermChan === void 0 ? _noop.noop : _ref$onSearchTermChan;
  // https://github.com/reach/reach-ui/issues/709 workaround for reopening
  var inputRef = (0, _react.useRef)(null);
  var _usePopoverControl = (0, _usePopoverControl2.usePopoverControl)(inputRef),
    reopen = _usePopoverControl.reopen,
    key = _usePopoverControl.key,
    close = _usePopoverControl.close;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  var selectedOption = (0, _react.useMemo)(function () {
    return options.find(function (o) {
      return o.value === value;
    });
  }, [options, value]);
  var setSerchTermValue = function setSerchTermValue(searchTerm) {
    setSearchTerm(searchTerm);
    onSearchTermChange(searchTerm);
  };
  var _useSearchTerm = (0, _useSearchTerm2.useSearchTerm)(reopen, close, selectedOption, value, setSerchTermValue),
    searchTerm = _useSearchTerm.searchTerm,
    setSearchTerm = _useSearchTerm.setSearchTerm,
    handleChange = _useSearchTerm.handleChange;
  var _useSelectHandlers = (0, _useSelectHandlers2.useSelectHandlers)(options, setSerchTermValue, onChange),
    handleSelect = _useSelectHandlers.handleSelect,
    handleClear = _useSelectHandlers.handleClear;
  var fixSelectedValueOnClose = (0, _useFixSelectedValueOnClose.useFixSelectedValuesOnClose)(selectedOption, searchTerm, setSerchTermValue, close);
  var handleAddNewClick = (0, _react.useCallback)(function () {
    onAddNewClick();
    close();
  }, [close, onAddNewClick]);
  var filteredResult = (0, _react.useMemo)(function () {
    if (selectedOption && selectedOption.label.text === searchTerm && selectedOption.value === value) {
      return options;
    }
    return options.filter(function (o) {
      return !searchTerm || o.label.text.toLowerCase().includes(searchTerm.toLowerCase());
    });
  }, [options, searchTerm, selectedOption, value]);
  var clearIconVisible = searchTerm && !disabled && clearable;
  return /*#__PURE__*/_react.default.createElement(_combobox.Combobox, {
    key: key,
    openOnFocus: true,
    onSelect: handleSelect,
    className: _searchSelectModule.default['search-select']
  }, /*#__PURE__*/_react.default.createElement(_CallbackOnClose.CallbackOnClose, {
    callback: fixSelectedValueOnClose
  }), /*#__PURE__*/_react.default.createElement(_combobox.ComboboxInput, {
    ref: inputRef,
    autoComplete: "off",
    id: id,
    className: (0, _classnames.default)(className, (0, _defineProperty2.default)({}, _searchSelectModule.default['search-select--with-clear-icon'], clearIconVisible)),
    onChange: handleChange,
    name: name,
    placeholder: placeholder,
    error: error,
    disabled: disabled,
    value: searchTerm,
    icon: /*#__PURE__*/_react.default.createElement(_search.ReactComponent, null),
    as: _InputWithIcon.InputWithIcon,
    suffix: /*#__PURE__*/_react.default.createElement("div", {
      className: _searchSelectModule.default['search-select__icons']
    }, clearIconVisible && /*#__PURE__*/_react.default.createElement(_remove.ReactComponent, {
      className: _searchSelectModule.default['search-select__icon'],
      onClick: handleClear,
      "data-testid": "clear-icon"
    }), /*#__PURE__*/_react.default.createElement(_chevronDown.ReactComponent, {
      className: _searchSelectModule.default['search-select__icon'],
      onClick: reopen
    }))
  }), /*#__PURE__*/_react.default.createElement(_combobox.ComboboxPopover, {
    "data-testid": "popover"
  }, /*#__PURE__*/_react.default.createElement(_Paper.Paper, {
    className: _searchSelectModule.default['search-select__paper'],
    inModal: inModal
  }, /*#__PURE__*/_react.default.createElement(_combobox.ComboboxList, {
    className: _searchSelectModule.default['search-select__list']
  }, filteredResult.length > 0 ? filteredResult.map(function (o) {
    return /*#__PURE__*/_react.default.createElement(_combobox.ComboboxOption, {
      value: o.label.text,
      key: o.value,
      as: _Option.Option,
      selected: o.value === value
    }, o.label.node ? o.label.node : o.label.text);
  }) : /*#__PURE__*/_react.default.createElement(_Option.Option, null, t('searchSelect.noOptions'))), withAddNew && /*#__PURE__*/_react.default.createElement("div", {
    onClick: handleAddNewClick,
    className: _searchSelectModule.default['search-select__add-new']
  }, /*#__PURE__*/_react.default.createElement(_plusCircled.ReactComponent, {
    className: _searchSelectModule.default['search-select__add-icon']
  }), addNewLabel))));
}